import WalletList from '@/components/modules/wallet/list/index.vue';
import WalletShow from '@/components/modules/wallet/show/index.vue';

const wallet = [
  {
    path: '/wallet',
    name: 'Wallet',
    component: WalletList,
    meta: {
      title: 'Wallet',
      requiresAuth: true,
    },
  },
  {
    path: '/wallet/:transporterId',
    name: 'WalletShow',
    component: WalletShow,
    meta: {
      title: 'Wallet',
      requiresAuth: true,
    },
  },
];

export default wallet;
